import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import { urlListeSideBarExpert } from '../../../data/Interfaces';
import useWindowSize from '../../../hooks/useWindowSize';

function DonneeProfile() {

    const wholepageocrstyle = {
        display:'flex',
        flexDirection:'row',
        gap:'20px',
        alignSelf:'stretch',
    };

    const menuglobalstyleOpen = {

        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '16px',
        gap: '4px',
        //width:'15%',
        height:'fit-content',
        background: '#FFFFFF',
        border: '1px solid #7083DD',
        borderRadius: '10px',
    };

    const {pathname} = useLocation();
    const curPath = pathname.split('/').pop();
    const {device}=useWindowSize();
    const navigate = useNavigate();
    const [urlPage,setUrlPage]=useState('');
    const { i18n } = useTranslation();
    useEffect(() => {
        if(pathname){
            setUrlPage(pathname);
        }

    },[pathname]);

    const handleChangeUrl = async (e) => {
        const newUrl = e.target.value;
        await setUrlPage(newUrl);
        navigate(newUrl, { replace: true });
    };

    return (
        <>
            <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',alignSelf:'stretch',gap:'16px'}}>
                <div className='frame5Profile'>{i18n.t('Mon compte')}   &gt; <span style={{color:'rgba(39, 45, 60, 1)'}}>{i18n.t('Données profil')} </span> </div>
                {device=='desktop' &&
                    (() => {
                        switch (curPath) {
                        case 'donneeProfile':
                            return (
                                <div style={wholepageocrstyle}>
                                    <div style = {menuglobalstyleOpen}>
                                        <div  className='kbismenustyle fiscalselectedmenustyle'>
                                            <Link
                                                to="."
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <p  className='textotherstyle textcardidstyle'>{i18n.t('Profil personnel')}</p>
                                            </Link></div>
                                        <div  className='kbismenustyle'>
                                            <Link
                                                to="donneesCV"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <p  className='textotherstyle'>{i18n.t('Données CV')}</p>
                                            </Link>
                                        </div>
                                        <div  className='kbismenustyle'>
                                            <Link
                                                to="preferences"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <p  className='textotherstyle'>{i18n.t('Préférences')}</p>
                                            </Link>
                                        </div>
                                        <div  className='kbismenustyle'>
                                            <Link
                                                to="societe"
                                                style={{ textDecoration: 'none' }}
                                            ><p  className='textotherstyle'>{i18n.t('Société')}</p>
                                            </Link>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex',width:'85%',flexDirection: 'column', alignItems: 'center',justifyContent:'center'}}>
                                        <Outlet />
                                    </div>
                                </div>
                            );
                        case 'donneesCV':
                            return (
                                <div style={wholepageocrstyle}>
                                    <div style = {menuglobalstyleOpen}>
                                        <div  className='kbismenustyle'>
                                            <Link
                                                to="."
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <p  className='textotherstyle'>{i18n.t('Profil personnel')}</p>
                                            </Link>
                                        </div>
                                        <div  className='kbismenustyle fiscalselectedmenustyle'>
                                            <Link
                                                to="donneesCV"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <p  className='textotherstyle textcardidstyle'>{i18n.t('Données CV')}</p>
                                            </Link>
                                        </div>
                                        <div  className='kbismenustyle'>
                                            <Link
                                                to="preferences"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <p  className='textotherstyle'>{i18n.t('Préférences')}</p>
                                            </Link>
                                        </div>
                                        <div  className='kbismenustyle'>
                                            <Link
                                                to="societe"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <p  className='textotherstyle'>{i18n.t('Société')}</p>
                                            </Link>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex',width:'85%',flexDirection: 'column', alignItems: 'center',justifyContent:'center'}}>
                                        <Outlet />
                                    </div>
                                </div>
                            );
                        case 'preferences':
                            return (
                                <div style={wholepageocrstyle}>
                                    <div style = {menuglobalstyleOpen}>
                                        <div  className='kbismenustyle'>
                                            <Link
                                                to="."
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <p  className='textotherstyle'>{i18n.t('Profil personnel')}</p>
                                            </Link>
                                        </div>
                                        <div  className='kbismenustyle'>
                                            <Link
                                                to="donneesCV"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <p  className='textotherstyle'>{i18n.t('Données CV')}</p>
                                            </Link>
                                        </div>
                                        <div className='kbismenustyle fiscalselectedmenustyle'>
                                            <Link
                                                to="preferences"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <p  className='textotherstyle textcardidstyle'>{i18n.t('Préférences')}</p>
                                            </Link>
                                        </div>
                                        <div  className='kbismenustyle'>
                                            <Link
                                                to="societe"
                                                style={{ textDecoration: 'none' }}
                                            ><p  className='textotherstyle'>{i18n.t('Société')}</p>
                                            </Link>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex',width:'85%',flexDirection: 'column', alignItems: 'center',justifyContent:'center'}}>
                                        <Outlet />
                                    </div>

                                </div>

                            );
                        case 'societe':
                            return (
                                <div style={wholepageocrstyle}>
                                    <div style = {menuglobalstyleOpen}>
                                        <div  className='kbismenustyle'>
                                            <Link
                                                to="."
                                                style={{ textDecoration: 'none' }}
                                            ><p  className='textotherstyle'>{i18n.t('Profil personnel')}</p>
                                            </Link>
                                        </div>
                                        <div  className='kbismenustyle'>
                                            <Link
                                                to="donneesCV"

                                                style={{ textDecoration: 'none' }}
                                            ><p  className='textotherstyle'>{i18n.t('Données CV')}</p>
                                            </Link>
                                        </div>
                                        <div  className='kbismenustyle'>
                                            <Link
                                                to="preferences"

                                                style={{ textDecoration: 'none' }}
                                            ><p  className='textotherstyle'>{i18n.t('Préférences')}</p>
                                            </Link>
                                        </div>
                                        <div  className='kbismenustyle fiscalselectedmenustyle'>
                                            <Link
                                                to="societe"

                                                style={{ textDecoration: 'none' }}
                                            ><p  className='textotherstyle textcardidstyle'>{i18n.t('Société')}</p>
                                            </Link>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex',width:'85%',flexDirection: 'column', alignItems: 'center',justifyContent:'center'}}>
                                        <Outlet />
                                    </div>
                                </div>

                            );

                        default:
                            return null;
                        }}
                    )()

                }
                {device!='desktop' &&
                <div
                    style={{
                        display:'flex',
                        flexDirection:'column',
                        gap:'20px',
                        alignSelf:'stretch'
                    }}
                >
                    <div style={{widt:'100%',minWidth:'200px',maxWidth:'500px'}}>
                        <SelectComponent
                            val={urlPage}
                            setVal={(e) => handleChangeUrl(e)}
                            listVal={urlListeSideBarExpert}
                        />
                    </div>
                    <div style={{ display: 'flex',width:device=='desktop' ?'85%':'100%',flexDirection: 'column', alignItems: 'center',justifyContent:'center'}}>
                        <Outlet />
                    </div>
                </div>
                }
            </div>
        </>
    );
}

export default DonneeProfile;